module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('router-link', {
    attrs: {
      "to": "/printerTable"
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("返回出單機列表")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/crPrinterStore/' + _vm.$route.params.printer_id
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("新增門市綁定")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    名稱 (ID)\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                    出單機" + _vm._s(_vm.printerInfo.printer_id) + "號 (" + _vm._s(_vm.printerInfo.printer_id) + ")\n                  ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    類型\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                    " + _vm._s(_vm.printerInfo.printer_type) + "\n                  ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    辨識碼\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                    " + _vm._s(_vm.printerInfo.printer_identity) + "\n                  ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                    啟用\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.printerInfo.printer_is_enabled) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("啟用")]) : _vm._e(), _vm._v(" "), (!_vm.printerInfo.printer_is_enabled) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("未啟用")]) : _vm._e()])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.storeList), function(store, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": '/printerStore/' + _vm.$route.params.printer_id + '/' + store.store_id
      }
    }, [_vm._v(_vm._s(store.store_name) + " (" + _vm._s(store.store_id) + ")")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(store.binding_name) + " (" + _vm._s(store.binding_id) + ")")]), _vm._v(" "), _c('td', [(store.binding_is_enabled) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("啟用")]) : _vm._e(), _vm._v(" "), (!store.binding_is_enabled) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("未啟用")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": '/upPrinterStore/' + _vm.$route.params.printer_id + '/' + store.binding_id
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])])], 1)])
  }), 0)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("綁定店名 (ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("綁定名稱 (ID)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("啟用")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5be48f1e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/RealTime/PrinterInfo.vue
// module id = 2441
// module chunks = 1